import { LoadingArea } from '@consigli/facade';
import {
  useProjectId,
  useLayoutId,
  useLayoutFiles,
  useGetLayoutOptimizationQuery,
} from '@consigli/hooks';
import { convertFileToDocument } from '@consigli/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CardBasedFileDisplay, INPUT_SECTIONS } from '@/components/card-based-file-display';
import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { WorkspaceProvider } from '@/layouts/workspace-layout/use-workspace-context';
import { WorkspaceLayout } from '@/layouts/workspace-layout/workspace-layout';

export const EngineeringInputPage: FC = () => {
  const projectId = useProjectId();
  const layoutId = useLayoutId();
  const { t } = useTranslation();

  const { files, isLoading, isFetching } = useLayoutFiles({
    projectId,
    layoutId,
    page: 'all',
  });
  const { data: layout } = useGetLayoutOptimizationQuery({ projectId, layoutId });

  const isPublished = layout ? layout.published : false;

  return (
    <>
      <Breadcrumb label={t('optimization-tabs.input')} />
      <WorkspaceProvider>
        <WorkspaceLayout>
          {isLoading ? (
            <LoadingArea title={t('document-list.loading')} />
          ) : files.length > 0 ? (
            <div className="flex">
              <CardBasedFileDisplay
                files={files.map((file) => convertFileToDocument(file))}
                isFetching={isFetching}
                isPublished={isPublished}
                sections={INPUT_SECTIONS}
              />
            </div>
          ) : (
            <div className="flex justify-center items-center w-full h-full text-[24px]">
              {t('document-list.no-documents')}
            </div>
          )}
        </WorkspaceLayout>
      </WorkspaceProvider>
    </>
  );
};
